var path = 'public/app/plugins/datasource/opentsdb/partials/annotations.editor.html';
var html = "<div class=gf-form-group>\n  <div class=gf-form>\n    <span class=\"gf-form-label width-13\">OpenTSDB metrics query</span>\n    <input type=text class=gf-form-input ng-model=ctrl.annotation.target placeholder=events.eventname>\n  </div>\n  <gf-form-switch class=gf-form label=\"Show Global Annotations?\" checked=ctrl.annotation.isGlobal switch-class=max-width-6 label-class=width-13></gf-form-switch>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./public/app/plugins/datasource/opentsdb/partials/annotations.editor.html
// module id = 647
// module chunks = 5